import create, { StateCreator } from "zustand"
import { Product } from "../hooks/data/useProducts";
import { persist, PersistOptions } from "zustand/middleware"
import { v4 as uuidv4 } from 'uuid';

export interface BasketItem extends Product {
    quantity: number
}

interface WebShopStore {
    basket: BasketItem[],
    addToBasket: (basketItem: BasketItem) => void
    removeFromBasket: (basketItem: BasketItem) => void
    clearBasket: () => void
}

type MyPersist = (
    config: StateCreator<WebShopStore>,
    options: PersistOptions<WebShopStore>
) => StateCreator<WebShopStore>

const useWebShopStore = create<WebShopStore>(
    (persist as unknown as MyPersist)(
        set => ({
            basket: [],
            addToBasket: (basketItem) => set(state => ({
                basket: [
                    ...state.basket,
                    {
                        ...basketItem,
                        id: uuidv4()
                    }
                ]
            })),
            removeFromBasket: (basketItem) => set(state => ({
                basket: state.basket.filter((row) => row !== basketItem),
            })),
            clearBasket: () => set(() => ({
                basket: []
            }))
        }),
        {
            name: 'bxwm-webshop-basket'
        }
    )
);


export default useWebShopStore;